import React, { useState, useMemo } from "react";
import { IconTimeLight, skinVars, Text1, Text, IconWarningRegular } from "@telefonica/mistica";
import { observer, useLocalObservable } from "mobx-react-lite";
import { strings } from "../../../../localization";
// import Feedback from "../../../../components/templates/Feedback";
import { useInterval } from "../../../../hooks/useInterval";
import { Store } from "../store";
import { useGlobalStore } from "../../../../contexts/globalStoreContext";
import { ReasonsCode, StatusFraudAnalysis } from "../../../../enum";
import { useAnalytics, useNavigateCustom } from "../../../../hooks";
import { ScreenResponsive } from "../../../../components";
import { HeroDataInfo } from "../../../../components/organisms";
import Loading from "../components/Loading";
import { Box, Flex } from "@chakra-ui/react";
import { colors } from "../../../../theme/colors";

const { steps: stepsTexts } = strings.pages.validateDocumentsUnderAnalysis;

const INTERVAL_VALUE_CHECK = 20 * 1000;

const ValidateDocumentsUnderAnalysis: React.FC = observer(() => {
	const { authenticationStore } = useGlobalStore();
	const store = useLocalObservable(() => new Store(authenticationStore));
	const { updatePageView } = useAnalytics();
	const [currStep, setCurrStep] = useState(0);
	const navigate = useNavigateCustom();

	useInterval(async (): Promise<void> => {
		await store.fetchStatus();

		switch (store.getStatus) {
			case StatusFraudAnalysis.APPROVED:
				navigate("/fintech-registration/validate-documents/approved");
				break;
			case StatusFraudAnalysis.DISAPPROVED:
				navigate("/fintech-registration/validate-documents/refused");
				break;
			case ReasonsCode.DOCUMENT_ERROR:
				navigate("/error-old-document");
				break;
			case ReasonsCode.UNDERAGE_DOCUMENT_ERROR:
				navigate("/underage-costumer");
				break;
			default:
				break;
		}
	});

	useInterval(async (): Promise<void> => {
		if (currStep < steps.length - 1) {
			setCurrStep(currStep + 1);
		}
	}, INTERVAL_VALUE_CHECK);


	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money Cadastro FGTS Documentos Enviados",
			pagePath: "/cadastro-fgts/documentos-enviados",
		});
	}, [updatePageView]);

	const steps = useMemo(
		() =>
			stepsTexts.map((item, index) => ({
				...item,
				loading: index !== stepsTexts.length - 1,
			})),
		[stepsTexts],
	);

	return (
		<ScreenResponsive>
			<Box paddingBottom="58px">
				<HeroDataInfo
					icon={<IconTimeLight size={64} color={skinVars.colors.brand} />}
					title={stepsTexts[currStep]?.title}
					description={stepsTexts[currStep]?.description}
				/>
				{steps[currStep]?.loading && (
					<Box
						sx={{
							background: "#F7F7F7",
							padding: "24px 16px",
							maxWidth: "600px",
							borderRadius: "16px",
							margin: "24px auto",
						}}
					>
						<Loading />
						{stepsTexts[currStep]?.loadingText && (
							<Flex justifyContent="center" alignItems="center" marginTop="16px">
								<Text1 medium textAlign='center' color={skinVars.colors.textSecondary}>
									{stepsTexts[currStep]?.loadingText}
								</Text1>
							</Flex>
						)}
					</Box>
				)}
				{currStep > 2 && stepsTexts[currStep]?.helperText && (
					<Box
						sx={{
							background: colors.white[700],
							padding: "24px 16px",
							maxWidth: "600px",
							borderRadius: "8px",
							margin: "24px auto",
						}}
					>
						<Flex gap="16px" align="center">
							<Flex>
								<IconWarningRegular size={24} color={skinVars.colors.textSecondary} />
							</Flex>
							<Flex>
								<Text size={12} color={skinVars.colors.textSecondary}>
									{stepsTexts[currStep]?.helperText}
								</Text>
							</Flex>
						</Flex>
					</Box>
				)}
			</Box>
		</ScreenResponsive>
	);
});

export default ValidateDocumentsUnderAnalysis;
